










import { defineComponent, PropType } from '@vue/composition-api';

import PhysicalExerciseBaseForm from './PhysicalExerciseBaseForm.vue';
import { usePhysicalExercise } from '@/bundles/VideoContent/composables/usePhysicalExercise';

interface PhysicalExercise {
  id: string;
  name: string;
  description: string;
  thumbnail: string;
  video: string;
  duration: number;
}

export default defineComponent({
  name: 'PhysicalExerciseEditForm',

  components: {
    PhysicalExerciseBaseForm,
  },

  emits: ['updated'],

  props: {
    exercise: {
      type: Object as PropType<PhysicalExercise>,
      required: true,
    },
  },

  setup(props, { emit }) {
    const { updateExercise } = usePhysicalExercise();

    const handleSubmit = async (data: any) => {
      await updateExercise(+props.exercise.id, data);
      emit('updated');
    };

    return {
      handleSubmit,
    };
  },
});
